export default "__VITE_ASSET__Dmr9iDW4__"